import useCoreStore from "views/hooks/useCoreStore";
import { Content } from "antd/es/layout/layout";
import { useTranslation } from "react-i18next";
import Footer from "components/Footer/Footer";
import { useForm } from "antd/es/form/Form";
import { FaFileAlt, FaPaperclip } from "react-icons/fa";
import { MdEmail } from "react-icons/md";
import EmailAttachments from "./components/EmailAttachments";
import Email from "./components/Email";
import { routes } from "config/routes";
import { Tabs } from "antd";
import React, { useEffect, useRef } from "react";
import Template from "./components/Template";

export default function Customization(): React.ReactElement {
  const { t } = useTranslation();
  const [form] = useForm();

  const companySelected = useCoreStore(state => state.companySelected);
  const contentRef = useRef<HTMLDivElement>(null);
  const pathSegments = window.location.pathname.split("/");
  const activeTabKey = pathSegments[pathSegments.length - 1];

  const handleOnChange = (key: string) => {
    routes.navigate(`/company/${companySelected?.id}/settings/customization/${key}`);
  };

  const TABS_OPTIONS = [
    {
      key: "template",
      label: (
        <span className="tab-icon-container">
          <FaFileAlt />
          {t("Template")}
        </span>
      ),
      children: <Template form={form} />,
    },
    {
      key: "email",
      label: (
        <span className="tab-icon-container">
          <MdEmail />
          {t("E-MAIL")}
        </span>
      ),
      children: <Email />,
    },
    {
      key: "attachments",
      label: (
        <span className="tab-icon-container">
          <FaPaperclip />
          {t("Attachments")}
        </span>
      ),
      children: <EmailAttachments />,
    },
  ];

  useEffect(() => {
    const contentElement = contentRef.current;
    if (!contentElement) return;

    const handleScroll = () => {
      const scrollTop = contentElement.scrollTop;
      const tabsNav = document.querySelector(".ant-tabs-nav");
      if (tabsNav) {
        if (scrollTop > 12) {
          tabsNav.classList.add("scrolled");
        } else {
          tabsNav.classList.remove("scrolled");
        }
      }
    };

    contentElement.addEventListener("scroll", handleScroll);

    return () => {
      contentElement.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <>
      <Content className="layout-card-content__with-tabs" ref={contentRef}>
        <Tabs
          className="antd-newrai-tabs"
          defaultActiveKey={activeTabKey}
          items={TABS_OPTIONS}
          onChange={handleOnChange}
        />
      </Content>
      <Footer />
    </>
  );
}
